/* ============
 * README
 * ============
 * By: espinozasenior@gmail.com
 */

/* ============
 * Vue
 * ============
 *
 * Vue.js is a library for building interactive web interfaces.
 * It provides data-reactive components with a simple and flexible API.
 *
 * http://rc.vuejs.org/guide/
 */
import Vue from 'vue';

import moment from 'moment';

Vue.config.debug = process.env.NODE_ENV !== 'production';

/* ===========
*   Services
*  ===========
*/

/*
* Vue resource is depricated currently but we use it b the Vue's plugins
*/
import VueResource from 'vue-resource';

Vue.use(VueResource);

/* ============
 * Vuex Router Sync
 * ============
 *
 * Effortlessly keep vue-Router and vuex store in sync.
 *
 * https://github.com/vuejs/vuex-router-sync/blob/master/README.md
 */
import VuexRouterSync from 'vuex-router-sync';

import store from './app/store';
// import localServices from './app/services/locals';

store.dispatch('checkAuthentication');

/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js
 *
 * https://kazupon.github.io/vue-i18n/
 */
import VueI18n from 'vue-i18n';
import messages from './app/locale';

Vue.use(VueI18n);

if (localStorage.getItem('lang') !== null) {
  Vue.config.lang = localStorage.getItem('lang');
} else {
  // Set language = en when user is from US
  const browserLang =  navigator.languages && navigator.languages[0] || navigator.language ||navigator.userLanguage;
  if(browserLang=='en-US' || browserLang=='en'){
    Vue.config.lang = 'en';
  }else{
    Vue.config.lang = 'es';
  }
  localStorage.setItem('lang', Vue.config.lang);
}

export const i18n = new VueI18n({
  locale: Vue.config.lang,
  fallbackLocale: Vue.config.lang,
  messages,
});

/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */
import VueRouter from 'vue-router';

import routes from './app/routes';

Vue.use(VueRouter);

export const router = new VueRouter({
  //mode: 'history',
  routes,
  saveScrollPosition: false,
  linkActiveClass: 'is-active',
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    localStorage.setItem('to', to.path);
    next({
      name: 'login',
    });
  } else if (to.matched.some(m => m.meta.guest) && store.state.auth.authenticated) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: 'home',
    });
  } else {
    next();
  }
  // To turn up the scroll
  window.scrollTo(0, 0);
});
VuexRouterSync.sync(store, router);

Vue.router = router;

/* ==========
 * Token and constant init
 * ==========
 */
const defaultTokenPeru = '6248d85a9d5b6a13bfbde69b2bcb81db';
const defaultTokenChile = '6248d85a9d5b61234fbde69b2bcb81d7';
const defaultTokenColombia = '6248d85a9d5b61234fbde69b2bcb81d8';

if (localStorage.getItem('id_token') === null && window.location.hostname.search('.cl') !== -1) {
  /* First time in Chile */
  localStorage.setItem('id_token', defaultTokenChile);
  localStorage.setItem('codigoPais', 'CL');
  localStorage.setItem('media', 'https://www.mesa247.cl/');
} else if (localStorage.getItem('id_token') === null) {
  /* First time anywhere */
  localStorage.setItem('id_token', defaultTokenPeru);
  localStorage.setItem('codigoPais', 'PE');
  localStorage.setItem('media', 'https://www.mesa247.pe/');
}

localStorage.setItem('storage', 'https://img.mesa247.pe/');

if (localStorage.getItem('codigoPais')=='CL'){
  localStorage.setItem('supportPhone', '225 835 907');
  localStorage.setItem('supportCodPhone', '56');
}else{
  localStorage.setItem('supportPhone', '961 771 473');
  localStorage.setItem('supportCodPhone', '51');
}

localStorage.setItem('storage', 'https://img.mesa247.pe/');

if (localStorage.getItem('codigoPais')=='CL'){
  localStorage.setItem('supportPhone', '225 835 907');
  localStorage.setItem('supportCodPhone', '56');
}else{
  localStorage.setItem('supportPhone', '961 771 473');
  localStorage.setItem('supportCodPhone', '51');
}
/* ============
 * Init main tab from main navbar
 * ============
 */
localStorage.setItem('homeTab', '1');

/* ============
 * Reset last request timeout
 * ============
*/

localStorage.removeItem('lastRequest');

/* ============
 * Mint UI for mobile apps
 * ============
 *
 *
 * http://mint-ui.github.io/
 */
import Mint from 'mint-ui';

import 'mint-ui/lib/style.css';

Vue.use(Mint);

/* =============
 * Some filter's helpers
 */
Vue.filter('withoutSeconds', (value) => {
  const v = value.split(':');
  return `${v[0]}:${v[1]}`;
});
Vue.filter('uppercase', (value) => value.toUpperCase());
Vue.filter('friendlyDate', (value) => moment(value).locale(Vue.config.lang).format('MMMM D YYYY'));
Vue.filter('dateFrom', (value) => moment(value).locale(Vue.config.lang).startOf('day').fromNow());
Vue.filter('dateTo', (value) => moment(value).locale(Vue.config.lang).endOf('day').fromNow());


/* ============
 * Styling
 * ============
 *
 * Require the application styling.
 * Sass is used for this boilerplate.
 *
 * If you don't want to use Sass, that's fine!
 */
require('./assets/sass/app.sass');

/* =============
 * Block landscape orientation
 * =============
 */

export default {
  router,
  i18n,
};



// WEBPACK FOOTER //
// ./src/bootstrap.js